export enum PERMISSION {
    UCDP_OVERWRITER = 'intelligence:ucdp-overwriter',
    QUEUES_MANAGER = 'intelligence:queues-mgr'
}